// Note(peter)#935: referenced from https://github.com/orgs/react-hook-form/discussions/1991#discussioncomment-31308
export const getDirtyValues = (
  dirtyFields: Record<string, any>,
  allValues: Record<string, any>
): Record<string, any> => {
  return Object.fromEntries(
    Object.keys(dirtyFields).map((key) => [key, allValues[key]])
  );
};
